import { datadogRum } from "@datadog/browser-rum"
import { sendGTMEvent } from "@/lib/google"
import { type DataLayerEventData } from "../types/dataLayerEventData"
import { SessionIdManager } from "./SessionIdManager"

export class DataLayer extends SessionIdManager {
    /**
     * Sends a data layer event with the specified parameters.
     * @param {string} event - The event name to be sent to the GTM data layer.
     * @param {DataLayerEventData} [data] - Optional additional data to include in the event.
     */
    public sendDataLayerEvent(event: string, data?: DataLayerEventData) {
        const payload = {
            event,
            timestamp: Date.now(),
            session_id: this.sessionId,
            ...data,
        }

        sendGTMEvent(payload)
        datadogRum.addAction(event, payload)
    }
}
